module.exports = require("@prisma/adapter-pg");